import Rock from './Rock';

export default Rock;